import { g as f, a as v, j as e, b as w, s as y } from "./country-d4e42059.js";
import { useState as j, useRef as T, useEffect as C, useMemo as N, useLayoutEffect as S } from "react";
import { s as r, L as B, u as L, a as P, B as M, c as _, Q as E } from "./index-384e14bf.js";
import { u as O, b as R, c as I } from "./index-23ca9bfe.js";
import { B as k } from "./helper-4f6e6639.js";
import { L as W } from "./LoginOpt-0950fbbf.js";
import { i as m } from "./lib-1be19634.js";
const H = ({ getStarted: u }) => {
  const i = f("sessionid"), s = O(), o = s.get("referral_code"), a = s.get("invited_source"), [c, l] = j(!1), t = T(null), p = I(), h = window.location.href, d = v(), { logoutRequest: g } = R();
  return C(() => {
    i != null && o && a && !t.current && l(!0);
  }, [o, a, i]), /* @__PURE__ */ e.jsx(e.Fragment, { children: c ? /* @__PURE__ */ e.jsx("div", { className: r.vipUserPromptWrap, children: /* @__PURE__ */ e.jsxs("div", { className: r.vipUserPrompt, children: [
    /* @__PURE__ */ e.jsx("p", { children: u.vipText.promptDesc }),
    /* @__PURE__ */ e.jsxs("div", { className: r.buttonContent, children: [
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: r.returnButton,
          onClick: (n) => {
            n.preventDefault(), l(!1), t.current = 1, p.push(`/${d}`);
          },
          children: u.vipText.returnHome
        }
      ),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: r.exitButton,
          onClick: () => {
            g({
              source: "web"
            }).then(() => {
              w("userKey"), w("sessionid"), l(!1), p.push(h);
            });
          },
          children: u.vipText.signOut
        }
      )
    ] })
  ] }) }) : null });
}, z = new k("SWITCH_LOGIN_TYPE"), Q = (u) => {
  var h, d, g;
  const { className: i = "", onChange: s, dictionary: o } = u, [a, c] = j("jobSeeker"), l = ((h = window == null ? void 0 : window.location) == null ? void 0 : h.pathname) || "", t = (o == null ? void 0 : o.getStarted) || {};
  C(() => {
    const n = f("loginType") || "jobSeeker";
    c(n);
  }, [l]);
  const p = (n) => {
    c(n), y("loginType", n), s && s(n), z.postMessage({
      message: {
        type: "SWITCH_LOGIN_TYPE",
        data: n
      },
      targetOrigin: window.origin
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: r.switchWrapper + " " + i, children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: r.switchOption,
        onClick: () => p("jobSeeker"),
        children: ((d = t == null ? void 0 : t.switch) == null ? void 0 : d.jobSeeker) || "Job Seeker"
      }
    ),
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: r.switchOption,
        onClick: () => p("recruiter"),
        children: ((g = t == null ? void 0 : t.switch) == null ? void 0 : g.recruiter) || "Recruiter"
      }
    ),
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: r.switchSlider,
        style: {
          left: a === "jobSeeker" ? "4px" : "50%"
        }
      }
    )
  ] });
}, G = new k("SWITCH_LOGIN_TYPE"), x = {
  "en-us": ["Start looking for a job"],
  "zh-cn": ["开始找工作"],
  "zh-tw": ["開始找工作"],
  tr: ["İş Aramaya Başla"],
  ms: ["Mula Cari Kerja"],
  id: ["Mulai Cari Kerja"],
  ja: ["求人を探し始める"],
  "es-es": ["Buscar Empleo"],
  "pt-br": ["Buscar Emprego"]
}, b = {
  "en-us": ["Start recruiting now"],
  "zh-cn": ["立即招人"],
  "zh-tw": ["立即招人"],
  tr: ["Personel Bulmaya Başla"],
  ms: ["Mula Mengambil Pekerja"],
  id: ["Mulai Rekrut Sekarang"],
  ja: ["採用を始める"],
  "es-es": ["Empieza a Contratar"],
  "pt-br": ["Comece a Recrutar"]
}, U = (u) => {
  var d;
  const { bannerType: i, dictionary: s } = u, { getStarted: o = {} } = s, a = v(), c = i == B.neptune, [l, t] = j("jobSeeker"), p = ((d = window == null ? void 0 : window.location) == null ? void 0 : d.pathname) || "";
  C(() => {
    const g = f("loginType") || "jobSeeker";
    t(g), G.onmessage = (n) => {
      n.message.type === "SWITCH_LOGIN_TYPE" && t(n.message.data);
    };
  }, [p]);
  const h = N(() => m ? x[a] || x["en-us"] : l === "recruiter" ? b[a] || b["en-us"] : x[a] || x["en-us"], [l, a]);
  return c ? /* @__PURE__ */ e.jsxs("div", { className: r.headerTitle2, children: [
    o == null ? void 0 : o.title,
    " ",
    /* @__PURE__ */ e.jsx("span", { children: "Neptune" })
  ] }) : c ? null : /* @__PURE__ */ e.jsxs(
    "div",
    {
      style: {
        fontSize: 32,
        fontWeight: 700,
        lineHeight: "110%",
        color: "#121212",
        marginBottom: 30
      },
      children: [
        /* @__PURE__ */ e.jsx("div", { className: r.headerTitle, children: h.join(", ") }),
        m ? null : /* @__PURE__ */ e.jsx(Q, { dictionary: s })
      ]
    }
  );
}, $ = (u) => {
  const {
    dictionary: i,
    isModal: s = !1,
    handleEmailClick: o,
    handlePhoneClick: a,
    bannerType: c = "2"
  } = u, { getStarted: l = {} } = i, [t, p] = j(!1), h = T(null), d = new URLSearchParams(location.search);
  L(c);
  const g = (n) => {
    p(n), n && h.current.getQrCodeFun();
  };
  return S(() => {
    const n = d.get("redirect");
    n && y("__redirect", n);
  }, [d]), /* @__PURE__ */ e.jsxs("div", { style: m || s ? { width: "100%" } : {
    width: 1024,
    height: 640,
    display: "flex",
    flexDirection: "row",
    padding: 16,
    borderRadius: 16,
    boxShadow: "0px 4px 6px 0px rgba(162, 183, 203, 0.10)"
  }, children: [
    !(m || s) && /* @__PURE__ */ e.jsx("div", { className: r.leftContainer, children: /* @__PURE__ */ e.jsx(P, { dictionary: i, bannerType: c }) }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        style: m || s ? {} : {
          flex: 1,
          padding: "20px 34px"
        },
        id: "right-container",
        className: r.rightContainer + " " + (s && !m ? r.mainModal : ""),
        children: [
          !m && !s && /* @__PURE__ */ e.jsx(
            "div",
            {
              onClick: () => {
              },
              style: {
                position: "absolute",
                top: 20,
                left: 34,
                width: 45,
                height: 45
              },
              children: /* @__PURE__ */ e.jsx(M, {})
            }
          ),
          /* @__PURE__ */ e.jsx(
            _,
            {
              setQrCode: g,
              qrCode: t,
              dictionary: i,
              isModal: s,
              isLeft: !1
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: t ? r.qrCodeWrapper : "hide", children: /* @__PURE__ */ e.jsx(E, { ref: h, open: t, lang: i }) }),
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              style: {
                marginTop: s ? 35 : 60,
                width: (s || m) && "100%",
                padding: !(s || m) && "0px 66px"
              },
              className: t ? "hide" : r.loginItems,
              children: [
                /* @__PURE__ */ e.jsx(U, { bannerType: c, dictionary: i }),
                /* @__PURE__ */ e.jsx(
                  W,
                  {
                    secondMax: 4,
                    handleEmailClick: o,
                    handlePhoneClick: a,
                    lang: i,
                    isModal: s
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ e.jsx(H, { getStarted: l })
        ]
      }
    )
  ] });
};
export {
  $ as M
};
//# sourceMappingURL=main-4d27099c.js.map
